import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cpn_admin_token";

export const authApi = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clearToken: () => localStorage.removeItem(TOKEN_KEY),
  isAuthenticated: () => !!localStorage.getItem(TOKEN_KEY),
  login: async (email, password, otp) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password, otp });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    return data;
  },
  logout: () => localStorage.removeItem(TOKEN_KEY),
};

export const authHeaders = () => ({
  Authorization: `Bearer ${authApi.getToken()}`,
});

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  return e?.message || "Something went wrong";
};
